import { isProduction, isTestingEmail } from '~lib/helpers'

export enum SLACK_DATA_TYPE {
  USER_LOGIN = 'user_login',
  GOOGLE_LOGIN = 'google_login',
  GOOGLE_SIGNUP = 'google_signup',
  ACCOUNT_CREATION = 'account_creation',
  TEMPLATE_UPLOAD = 'template_upload',
}

// TODO
const sendSlackMessage = (data: Record<string, any>) => {
  const { email, type } = data

  let body = ''

  if (!isProduction() || isTestingEmail(email)) {
    return
  }

  body = JSON.stringify({
    ...data,
  })

  fetch(`/api/sendSlackMessage?type=${type}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  })
}

export default sendSlackMessage
